document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.posts-slider');
    const desktopQuery = window.matchMedia('(min-width: 992px)');

    function isDesktop() {
        return desktopQuery.matches;
    }

    function mountSlider(slider) {
        const wrapper = slider.querySelector('.swiper-wrapper');
        const paginationEl = slider.querySelector('.posts-slider-pagination');

        if (!wrapper || !wrapper.querySelector('.swiper-slide')) {
            return;
        }

        const prevSwiper = slider._postsSwiper;

        if (prevSwiper && !prevSwiper.destroyed) {
            prevSwiper.destroy(true, true);
        }

        slider._postsSwiper = null;
        slider.classList.remove('posts-slider--grid', 'posts-slider--slider');
        slider.dataset.postsLayoutMode = isDesktop() ? 'desktop' : 'compact';

        if (isDesktop()) {
            slider.classList.add('posts-slider--grid');
            return;
        }

        slider.classList.add('posts-slider--slider');

        const swiperOptions = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
            speed: 500,
            watchOverflow: false,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 30,
                },
            },
        };

        if (paginationEl) {
            swiperOptions.pagination = {
                el: paginationEl,
                clickable: true,
            };
        }

        const swiper = new Swiper(slider, swiperOptions);

        slider._postsSwiper = swiper;
    }

    function debounce(fn, ms) {
        let t;

        return function () {
            clearTimeout(t);
            t = setTimeout(fn, ms);
        };
    }

    function subscribeMediaQuery(mm, handler) {
        if (typeof mm.addEventListener === 'function') {
            mm.addEventListener('change', handler);
        } else if (typeof mm.addListener === 'function') {
            mm.addListener(handler);
        }
    }

    sliders.forEach((slider) => {
        mountSlider(slider);

        const onBreakpointChange = debounce(() => {
            const mode = isDesktop() ? 'desktop' : 'compact';

            if (mode !== slider.dataset.postsLayoutMode) {
                mountSlider(slider);
            }
        }, 150);

        window.addEventListener('resize', onBreakpointChange);
        subscribeMediaQuery(desktopQuery, onBreakpointChange);
    });
});
